var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.82971 5.00928C7.80201 5.64675 6.06899 6.9881 4.94348 8.79121C3.81798 10.5943 3.37413 12.7404 3.69205 14.842C4.00998 16.9436 5.06873 18.8624 6.67721 20.2519C8.28568 21.6414 10.3379 22.4101 12.4634 22.4193C14.589 22.4285 16.6477 21.6776 18.2682 20.302C19.8886 18.9265 20.9639 17.017 21.3 14.9182C21.6361 12.8194 21.2109 10.6695 20.101 8.85678C18.9911 7.044 17.2698 5.68771 15.2477 5.03271",
    stroke: "#51546B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.6079V2.67041",
    stroke: "#51546B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.e711d83b5c81b82fe9c23e6884089292.svg";
export { ForwardRef as ReactComponent };